import {
  BackgroundColors,
  NegativeColors,
  PositiveColors,
} from '@picsart/design-system/foundation/colors';

import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';

import { DEFAULT_COLOR_SCHEME } from 'redesignedComponents/context/colorScheme';

const useStyles = createUseStyles<string, { colorScheme?: 'light' | 'dark' }>(
  () => ({
    root: ({ colorScheme }) => {
      return {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: [0, Spacings.s48],
        backgroundColor:
          colorScheme === DEFAULT_COLOR_SCHEME
            ? PositiveColors.base.default
            : NegativeColors.base.default,
        color:
          colorScheme === DEFAULT_COLOR_SCHEME
            ? PositiveColors.text.default
            : NegativeColors.text.default,
      };
    },
    mainContent: {
      maxWidth: 745,
    },
    title: {
      textAlign: 'center',
      paddingBottom: Spacings.s64,
      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        paddingBottom: Spacings.s16,
      },
    },
    section: {
      paddingBottom: Spacings.s24,
      paddingTop: Spacings.s24,
      borderBottom: `1px solid ${BackgroundColors.tint3}`,
    },
    iconWrapper: {
      minWidth: 48,
      maxWidth: 48,
      height: 48,
      cursor: 'pointer',
      background: `${PositiveColors.base.default}`,
      boxShadow: '0px 2px 8px rgba(17, 18, 54, 0.16)',
      borderRadius: '50%',
      marginLeft: Spacings.s24,
      '& > svg': {
        width: '100%',
        height: '100%',
        fill: `${BackgroundColors.tint3}`,
      },
    },
    contentWrapper: {
      maxWidth: 578,
      marginRight: Spacings.s64,
      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        maxWidth: 332,
      },
    },
    summaryItem: {
      width: '100%',
      maxWidth: 600,
      margin: 'auto',
    },
    cta: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      marginTop: Spacings.s32,
    },
    skeletonSection: {
      extend: 'section',
      height: 200,
    },
    skeletonTitle: {
      extend: 'title',
      height: 80,
      width: '40%',
      '& > i': {
        borderRadius: CornerRadius.r12,
      },
    },
    skeletonIconWrapper: {
      extend: 'iconWrapper',
      marginLeft: 'auto',
    },
    skeletonContentWrapper: {
      extend: 'contentWrapper',
      position: 'relative',
      bottom: 60,
      height: 20,
      width: '70%',
      '& > i': {
        borderRadius: CornerRadius.r12,
        marginBottom: Spacings.s12,
      },
    },
  }),
  {
    name: 'FAQ',
  },
);

export default useStyles;
